import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * MetaPixelRouteTracker — fires `fbq('track', 'PageView')` on every SPA
 * route change so Meta Pixel attribution is accurate in a client-side-only
 * navigation model.
 *
 * The initial PageView still fires from the inline script in `public/index.html`
 * (which runs before this component mounts). This component only handles the
 * follow-up SPA transitions. If `fbq` isn't loaded (ad-blocker, private
 * mode) it silently no-ops.
 *
 * Mounts once inside <BrowserRouter> — see App.js.
 */
const MetaPixelRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (typeof window.fbq !== 'function') return;   // ad-blocker or offline — no-op
    try {
      window.fbq('track', 'PageView');
    } catch (_e) { /* ignore — never break the app for analytics */ }
  }, [location.pathname]);

  return null;
};

export default MetaPixelRouteTracker;
